-- Browser providers keep the Nupp API in checked source. Their work crosses
-- one suspension boundary to the application Worker and its browser APIs.

local time = require("coroutine")
local mac = require("binary.mac")
local digests = require("binary.digest")

time.sleep(10)
local key = os.uuid4()
local digest = digests.hexdigest("sha256", os.randombytes(32))
print(key, digest)
print(mac.hexdigest("hmac-sha256", "key", "browser message"))

-- try breaking it: pass a negative count to randombytes and read the checked
-- provider error
